<div class="px-3 sm:px-0 mt-2">
  <soft-input placeholder="Person suchen..." class="rounded" [(value)]="searchValue">
    <soft-icon name="fa-regular fa-search" class="text-lighter"></soft-icon>
  </soft-input>

  <ul class="min-h-[55vh] max-h-[55vh] overflow-y-auto mt-2">
    @for (employee of filteredEmployees(); track employee.id) {
      @let selected = employee.id | in: selectedEmployeeIds();

      <li
        class="flex items-center justify-between w-full"
        [class.border-b]="!$last"
        (click)="
          $event.preventDefault();
          selected ? unselectEmployee(employee) : selectEmployee(employee)
        "
        >
        <div class="flex items-center gap-3 p-2 w-full">
          <soft-checkbox [checked]="selected" />
          <div class="flex flex-col items-start justify-start">
            <span class="text-sm text-lighter">{{ employee.persnr }}</span>
            <span class="text-base font-semibold"
              >{{ employee.vorname }} {{ employee.zuname }}</span
              >
            </div>
          </div>
        </li>
        } @empty {
        <div class="flex flex-col items-center justify-center my-4 gap-2 py-8 text-center">
          <soft-icon name="fa-regular fa-face-sad-tear fa-2x"></soft-icon>
          <span class="text-sm text-light">Keine Mitarbeiter gefunden</span>
        </div>
      }
    </ul>

    <div class="flex border-t w-full items-center justify-between py-2">
      <span class="text-sm text-light"
        >{{ selectedEmployeeIds().length }} von {{ allEmployees().length }} ausgewählt</span
        >
      </div>
    </div>

    <div class="c row no-wrap mt-0 flex items-center gap-4 pb-2 px-2 sm:px-0 sm:pb-0">
      <button class="soft-button secondary rounded fill-force" (click)="resolve(null)">
        {{ '#WORK_NOTE.DIALOGS.SIGNATURE.CANCEL_BTN' | translate }}
      </button>
      <button
        class="soft-button primary rounded fill-force"
        (click)="save()"
        [disabled]="selectedEmployeeIds().length < 1"
        >
        <span>
          @if (isSaving()) {
            <i class="fa-regular fa-spinner fa-spin"></i>
          }
          {{ '#WORK_NOTE.DIALOGS.SIGNATURE.SAVE_BTN' | translate }}
        </span>
      </button>
    </div>
